<template>
  <div class="login-page">
    <div class="login-card">
      <h2 class="title">智慧安全管理平台</h2>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="account" class="inputStyle">
          <el-input
            v-model.trim="form.account"
            placeholder="请输入账号"
            prefix-icon="el-icon-user"
            clearable
          />
        </el-form-item>
        <el-form-item prop="password" class="inputStyle">
          <el-input
            v-model.trim="form.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="handleLogin"
        >登 录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { login } from '../api'
import { setToken, setUser } from '../utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: { account: '', password: '' },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await login(this.form.account, this.form.password)
          if (res && res.code === 0) {
            setToken(res.token)
            // 兼容 userInfo 嵌套或字段平铺两种返回结构，确保 em_names/shenfen/id 可用
            setUser({ ...res, ...(res.userInfo || {}) })
            this.$message.success(res.msg || '登录成功')
            this.$router.replace('/training')
          } else {
            this.$message.error((res && res.msg) || '登录失败')
          }
        } catch (e) {
          this.$message.error('登录失败，请检查网络后重试')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
 width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  background: url("../img/login-bg.jpg");
    background-size: 100% 100%;
    position: fixed;
}

.login-card {
   position: absolute;
    top: 50%;
    left: 80%;
    transform: translate(-50%, -50%);
    /* border: 1px solid #FFFFFF; */
    /* background: #fff; */
    width: 18.75rem;
    height: 18.75rem;
    padding: 30px 30px 50px 30px;
    border-radius: 3px;
    background-image: url('../img/login-input.png');
    background-repeat: no-repeat;
    background-position: top;
    background-size: 100%;
}

.title {
  margin: 28px 0 28px;
  text-align: center;
  font-size: 20px;
  color: #fff;
}

.login-btn {
  width: 100%;
  margin-top: 4px;
}
  .inputStyle ::v-deep .el-input__inner {
    background-color: white !important;
    color: #333;
    /* 文字颜色设为深色 */
    border: 1px solid #333;
    border-radius: 6px;
    font-size: 14px;
  }

  /* 聚焦时效果 */
  .inputStyle ::v-deep .el-input__inner:focus {
    border-color: #007bff;
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.3);
  }

  /* 图标颜色调整（可选） */
  .inputStyle ::v-deep .el-input__prefix .el-icon-user,
  .inputStyle ::v-deep .el-input__prefix .el-icon-unlock {
    color: #666;
  }
</style>
